"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(err) {
  var extras = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var hasRaven = window && window.Raven && typeof window.Raven.captureException === 'function' && typeof window.Raven.captureMessage === 'function';

  if (hasRaven) {
    window.Raven.captureException(err, extras);
  }
};

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker-public/static-1.338/js/helpers/reportError.js
// module id = 241
// module chunks = 0